// src/components/Auth/SignupModal.jsx
import React, { useState } from "react";
import Modal from "../DynamicComp/modal";
import Input from "../DynamicComp/Input";
import Button from "../DynamicComp/Button";
import { IoEyeOffOutline, IoEyeOutline } from "react-icons/io5";
import { deleteData, postData, putData } from "../../global/Globalapi";
import { useNavigate } from "react-router-dom";
// import { toast } from "react-toastify";
import swal from "sweetalert";
const SignupModal = ({ isSignUp, setSignUp, setUser }) => {
  const [email, setEmail] = useState("");
  const [userpassword, setPassword] = useState("");
  const [mobile, setMobNo] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleSignUp = async () => {
    // e.preventDefault();
      if (!email.trim()) {
   swal("Email is required.");
    return;
  }

  if (!userpassword.trim()) {
    swal("Password is required.");
    return;
  }

  if (!mobile.trim()) {
  swal("Mobile number is required.");
    return;
  }
    const sessionID = ""
    let existinguser = null;
  try {
    const storedUser = localStorage.getItem("user");
    if (storedUser && storedUser !== "undefined" && storedUser !== "null") {
      existinguser = JSON.parse(storedUser);
    }
  } catch (e) {
    console.warn("Invalid JSON in localStorage for 'user':", e);
  }

    try {
      let api="/add_newUser"
      let payload={
        name: email,
        email,
        userpassword,
        mobile,
        username: email,
        usertype: "customer",
        userstatus: "Active",
        sessionid:sessionID
      }
      let response;
      
      console.log("Payload for signup:", payload);
      // if(existinguser && existinguser.usertype === "guest"){
      //   payload.userid=existinguser.id
      //   response = await putData("/session_update", payload);
      //   console.log("update function",payload)
      //   console.log("response",response)
      // }
      if(existinguser && existinguser.usertype === "guest"){
        payload.userid = existinguser.id;
      try {
       response = await putData("/session_update", payload);
       console.log("update function", payload);
       if(response.status){
        const deletesession=await deleteData("/session/destroy");
        console.log("Session destroyed:", deletesession);
       }
       console.log("response", response);
       } catch (err) {
       console.error("putData failed:", err);
      }
     }
      else{
        response = await postData(api, payload);
        console.log("insert function")
      }

      if (response.data) {
        const user = response.data.user;
        localStorage.setItem("user", JSON.stringify(user));
        setUser(user);
        setEmail("");
        setMobNo("");
        setPassword("");
        setSignUp(false);
        // navigate("/");
      }
    } catch (error) {
      console.error("Signup error:", error);
      swal(error.response?.data?.message || "Signup failed");
    }
  };

  return (
    <Modal isOpen={isSignUp} onClose={() => setSignUp(false)} title="Sign up">
      <div>
        <div className="mb-4">
          <Input
            type="email"
            value={email}
            placeholder="Email"
            onChange={(e) => setEmail(e.target.value)}
            className="w-full p-3 border rounded-lg outline-none focus:ring-1 focus:ring-black"
          />
        </div>
        <div className="mb-2 relative">
          <Input
            type={showPassword ? "text" : "password"}
            placeholder="Password"
            value={userpassword}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full p-3 border rounded-lg outline-none focus:ring-1 focus:ring-black"
          />
          <Button
            className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 bg-transparent p-0 border-none shadow-none hover:bg-transparent focus:ring-0"
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? <IoEyeOutline size={20} /> : <IoEyeOffOutline size={20} />}
          </Button>
        </div>
        <div className="mb-4">
          <Input
            type="text"
            value={mobile}
            placeholder="Mobile No"
            onChange={(e) => setMobNo(e.target.value)}
            className="w-full p-3 border rounded-lg outline-none focus:ring-1 focus:ring-black"
          />
        </div>
        <Button
          variant="black"
          className="w-full bg-black text-white p-3 rounded-lg text-lg font-semibold hover:bg-red-600"
          onClick={handleSignUp}
        >
          Create Account
        </Button>
      </div>
    </Modal>
  );
};

export default SignupModal;
